<template>
    <transition name="slide-width-fade">
        <div class="bg-white absolute top-0 left-14 justify-between z-20 pl-6 pr-6 w-80 h-72"
            v-if="$root.showSearch && $root.showMenu">

            <div class="absolute top-3 right-3">
                <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"
                    class="block w-3 h-3 mx-auto stroke-current text-green cursor-pointer"
                    v-on:click="$root.showSearch = !$root.showSearch"
                >
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path d="M11.689,23.25.97,12.53a.749.749,0,0,1,0-1.06L11.689.75" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                        <path d="M22.939,23.25,12.22,12.53a.749.749,0,0,1,0-1.06L22.939.75" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                    </g>
                </svg>
            </div>

            <!-- Search Modal -->
            <div v-if="$root.showSearch">
                <div class="relative mt-2">
                    <span class="flex-shrink-0 inline-block px-4 py-1 text-yellow-800 text-sm font-bold bg-yellow-100 rounded-full cursor-pointer"
                        v-on:click="clearSearch()"
                    >
                        Clear
                    </span>
                </div>

                <div class="relative mt-6">
                    <div v-if="$page.props.auth.user.role == 'admin'">
                        <!-- Organisations -->
                        <label id="listbox-label" class="block text-sm font-medium text-gray-700">
                            Organisation
                        </label>

                        <div class="mt-1 relative">
                            <button type="button"
                                v-on:click="$root.search.organisation.open = !$root.search.organisation.open"
                                class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
                                <input type="text" class="block w-full truncate p-0 border-none placeholder-gray-300 focus:ring-0"
                                    v-model="$root.search.organisation.search"
                                    @keyup="search"
                                    :placeholder="organisationPlaceholderText"
                                >

                                <!-- Dropdown open -->
                                <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" v-show="Object.entries($root.search.organisation.organisations).length > 0">
                                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                    </svg>
                                </span>
                            </button>

                            <ul class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3"
                                v-show="$root.search.organisation.open && Object.entries($root.search.organisation.organisations).length > 1"
                            >
                                <li class="text-gray-900 hover:bg-gray-100 cursor-pointer select-none relative py-2 pl-8 pr-4"
                                    role="option"
                                    v-for="(organisation, index) in $root.search.organisation.organisations"
                                    :key="organisation.id"
                                    v-on:click="selectOrganisation(index, organisation);"
                                    >
                                    <span class="font-normal block truncate"
                                        :class="$root.search.organisation.selected == index ? 'font-semibold' : 'font-normal'"
                                    >
                                        {{organisation}}
                                    </span>

                                    <span class="text-indigo-600 absolute inset-y-0 left-0 flex items-center pl-1.5"
                                        v-if="$root.search.organisation.selected == index"
                                    >
                                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Farmers -->
                    <label id="listbox-label" class="block text-sm font-medium text-gray-700 mt-6">
                        Farmer
                    </label>

                    <div class="mt-1 relative">
                        <button type="button"
                            v-on:click="$root.search.farmer.open = !$root.search.farmer.open"
                            class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
                            <input type="text" class="block w-full truncate p-0 border-none placeholder-gray-300 focus:ring-0"
                                v-model="$root.search.farmer.search"
                                @keyup="search"
                                :placeholder="farmerPlaceholderText"
                            >

                            <!-- Dropdown icon -->
                            <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                                v-show="Object.entries($root.search.farmer.farmers).length > 0">
                                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </span>
                        </button>

                        <ul class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3"
                            v-show="$root.search.farmer.open && Object.entries($root.search.farmer.farmers).length > 0"
                        >
                            <li class="text-gray-900 hover:bg-gray-100 cursor-pointer select-none relative py-2 pl-8 pr-4"
                                role="option"
                                v-for="(farmer, index) in $root.search.farmer.farmers"
                                :key="farmer.id"
                                v-on:click="selectFarm(index, farmer);"
                                >
                                <span class="font-normal block truncate"
                                    :class="$root.search.farmer.selected == index ? 'font-semibold' : 'font-normal'"
                                >
                                    {{farmer}}
                                </span>

                                <span class="text-indigo-600 absolute inset-y-0 left-0 flex items-center pl-1.5"
                                    v-if="$root.search.farmer.selected == index"
                                >
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="mt-4" v-if="$root.farmer.name !== undefined">
                    <!-- Farm -->
                    Selected Farm: <strong>{{$root.farmer.name}}</strong>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
export default {
    computed: {
        organisationPlaceholderText() {
            if (Object.keys(this.$root.search.organisation.organisations).length > 0) {
                return 'Select Organisation...';
            }

            return 'Search Organisation...';
        },
        farmerPlaceholderText() {
            if (Object.keys(this.$root.search.farmer.farmers).length > 0) {
                return 'Select Farmer...';
            }

            return 'Search Farmer...';
        }
    },
    methods: {
        search:_.debounce(function() {
            this.getData();
        }, 750),

        getData() {
            let search = {
                organisation: '',
                farmer: '',
                organisation_id: '',
            }

            if (this.$root.search.organisation.search.length == 0 && this.$root.search.farmer.search.length == 0) {
                this.clearSearch();
                return;
            }

            let intiateSearch = false;

            if (this.$root.search.organisation.search.length >= 3 && this.$root.search.organisation_id.length == 0) {
                search.organisation = this.$root.search.organisation.search;
                intiateSearch = true;
            }

            if (this.$root.search.organisation_id.length > 0) {
                search.organisation = '';
                search.organisation_id = this.$root.search.organisation_id;
            }

            if (this.$root.search.farmer.search.length >= 3) {
                search.farmer = this.$root.search.farmer.search;
                intiateSearch = true;
            }

            if (intiateSearch) {
                let vm = this;
                axios.post(route('app.search', search))
                    .then(function (response) {
                        vm.handleOrganisationsResponse(response.data.organisations);
                        vm.handleFarmersResponse(response.data.farmers);
                    })
            }
        },

        handleOrganisationsResponse(organisations) {
            if (Object.keys(organisations).length == 1) {
                for (var organisation in organisations) {
                    this.$root.search.organisation.search = organisations[organisation];
                    break;
                }
                this.$root.search.organisation.organisations = {};
            } else if (Object.keys(organisations).length > 1) {
                this.$root.search.organisation.organisations = organisations;
            } else {
                this.$root.organisations = {};
            }

            this.$root.search.organisation.selected = null;
            this.$root.search.organisation.open = false;
        },

        handleFarmersResponse(farmers) {
            if (Object.keys(farmers).length == 1) {
                for (const [index, farmer] of Object.entries(farmers)) {
                    this.$root.search.farmer.search = farmer;
                    this.selectFarm(index, farmer);
                    break;
                }
                this.$root.search.farmer.farmers = '';

            } else if (Object.keys(farmers).length > 1) {
                this.$root.search.farmer.farmers = farmers;
            } else {
                this.$root.search.farmer.farmers = '';
            }

            this.$root.search.farmer.selected = null;
            this.$root.search.farmer.open = false;
        },

        selectOrganisation(index, organisation) {
            this.$root.search.organisation.selected = index;
            this.$root.search.organisation.search = organisation;
            this.$root.search.organisation.open = false;
            this.$root.search.organisation_id = index;
            this.getData();
        },

        selectFarm(index, farmer) {
            this.$root.search.farmer.selected = index;
            this.$root.search.farmer.search = farmer;
            this.$root.search.farmer.open = false;
            let vm = this;

            axios.post(route('app.farmer.map.view', index))
                .then(function (response) {
                    vm.$root.farmer = response.data;
                    vm.$root.showSearch = false;
                })
        },

        clearSearch() {
            this.$root.search.organisation.search = '';
            this.$root.search.organisation.selected = null;
            this.$root.search.organisation.open = false;
            this.$root.search.organisation.organisations = {};
            this.$root.search.farmer.search = '';
            this.$root.search.farmer.selected = null;
            this.$root.search.farmer.open = false;
            this.$root.search.farmer.farmers = {};
            this.$root.search.organisation_id = '';
        }
    },
}
</script>
